import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { ATTRIBUTE_NAME_CONTACT_LENSES } from '../../components/product-page-context/ATTRIBUTE_NAME'

export const productAccessorIsContactLenses = (
  product: PimProductV11,
): boolean => {
  return (
    product.variant_attributes?.some((attribute) => {
      return attribute.group === ATTRIBUTE_NAME_CONTACT_LENSES
    }) ?? false
  )
}
